@if (dynamicFieldConfig) {
  <his-dynamic-container
    [dynamicFieldConfig]="dynamicFieldConfig">
  </his-dynamic-container>
}
